import { incrementMetric } from '../Services/Datadog';
import { sendFormErrorToGateway } from '../Services/Gateway/sendFormError';

// eslint-disable-next-line import/prefer-default-export
export const handleFormError = ({ eventObject, errorObject }) => {
  incrementMetric({
    name: 'formError', // REQUIRED: DD metric name
    tags: {
      error_thrown: errorObject.message, // needs to be hard coded, not a variable
      form_id: eventObject.formId,
    },
  });

  sendFormErrorToGateway({ eventObject, errorObject });
};
